<template>
    <v-main>
        <div class="stepper-4">
            <div id="move-step4">
                <StepperBar
                    v-if="registrationFormDetail"
                    :stepOn="StepperType"
                    :stepper="4"
                />
            </div>
        </div>
        <v-container class="spacing-playground form-margin-top">
            <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    md="7"
                    class="
                        d-flex
                        justify-md-end justify-sm-center justify-center
                    "
                >
                    <v-card
                        max-width="690"
                        elevation="0"
                        style="border-radius: 10px"
                    >
                        <v-card-text class="pb-10 pt-11 px-9">
                            <v-row>
                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="pb-c-17"
                                >
                                    <div
                                        v-if="
                                            student_status ===
                                            'PENDING_CONFIRMATION'
                                        "
                                    >
                                        <v-img
                                            :src="require('@/assets/right.svg')"
                                            contain
                                            height="60"
                                        />
                                    </div>
                                    <div
                                        v-else-if="
                                            student_status === 'NOT_QUALIFY' ||
                                            student_status === 'REJECTION'
                                        "
                                    >
                                        <v-img
                                            :src="require('@/assets/wrong.svg')"
                                            contain
                                            height="60"
                                        />
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="py-0"
                                >
                                    <div
                                        v-if="
                                            student_status ===
                                            'PENDING_CONFIRMATION'
                                        "
                                    >
                                        <div
                                            style="
                                                position: relative;
                                                z-index: 0;
                                            "
                                        >
                                            <lottie-animation
                                                class="anim_left"
                                                ref="anim"
                                                :loop="true"
                                                :animationData="
                                                    require('@/assets/124567-congrats')
                                                "
                                            />
                                            <lottie-animation
                                                class="anim_right"
                                                ref="anim"
                                                :loop="true"
                                                :animationData="
                                                    require('@/assets/124567-congrats')
                                                "
                                            />
                                        </div>
                                        <div class="prompt-title-page">
                                            {{
                                                $t(
                                                    "message.step4.topic.congratulations"
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        v-else-if="
                                            student_status === 'NOT_QUALIFY'
                                        "
                                    >
                                        <div class="prompt-title-page">
                                            {{
                                                $t(
                                                    "message.step4.topic.notPass"
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        v-else-if="
                                            student_status === 'REJECTION'
                                        "
                                    >
                                        <div class="prompt-title-page">
                                            {{$t("message.formSummit.successfulWaiver")}}
                                        </div>
                                    </div>
                                </v-col>

                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    v-if="
                                        student_status ===
                                        'PENDING_CONFIRMATION'
                                    "
                                    class="form-subtitle-400 px-md-16"
                                >
                                    <p v-if="(result_type == 'PASS' &&
                                                    !confirmationTimeout) ||
                                                (result_type == 'RESERVED' &&
                                                    !reservedConfirmationTimeout)">
                                        {{
                                            $t("message.step4.content.confirm")
                                        }}
                                    </p>
                                    <p v-else>
                                        {{$t("message.step4.content.timeout")}}
                                    </p>
                                </v-col>

                                <v-col cols="12" md="12" class="px-md-16 px-5">
                                    <div class="px-0">
                                        <div
                                            v-if="
                                                student_status ===
                                                    'NOT_QUALIFY' ||
                                                student_status === 'REJECTION'
                                            "
                                            class="py-3"
                                        >
                                            <v-divider></v-divider>
                                        </div>
                                        <v-row>
                                            <v-col>
                                                <div class="prompt-title">
                                                    {{
                                                        $t(
                                                            "message.step4.content.examinationResult"
                                                        )
                                                    }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="pt-0 pr-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step4.content.name"
                                                        )
                                                    }}
                                                </div>
                                                <div
                                                    class="pa-0 mt-0 pt-1 step4__text__size18"
                                                    v-if="
                                                        student?.student_detail
                                                    "
                                                >
                                                    {{ studentFullName }}
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="pt-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                {{ }}
                                                {{ student_status !==
                                                    'NOT_QUALIFY' ? $t(
                                                            "message.step4.content.type"
                                                        ) : "" }}
                                                    
                                                </div>
                                                <div
                                                    class="pa-0 mt-0 pt-1 step4__text__size18"
                                                >
                                                    {{ student_status !==
                                                    'NOT_QUALIFY' ? resultType : "" }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="pt-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step4.content.classroom"
                                                        )
                                                    }}
                                                </div>
                                                <div
                                                    class="pa-0 pt-1 step4__text__size18"
                                                    v-if="student?.register_plan"
                                                >
                                                    {{
                                                        student?.register_plan
                                                            ?.student_year
                                                            ?.[`student_year_name_${locale}`]
                                                    }}
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="pt-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step4.content.curriculum"
                                                        )
                                                    }}
                                                </div>
                                                <div
                                                    class="pa-0 pt-1 step4__text__size18"
                                                    v-if="student?.register_plan"
                                                >
                                                    {{
                                                        student?.register_plan
                                                            ?.program
                                                            ?.[`program_name_${locale}`]
                                                    }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            class="d-flex"
                                            v-if="
                                                (result_type == 'PASS' &&
                                                    !confirmationTimeout) ||
                                                (result_type == 'RESERVED' &&
                                                    !reservedConfirmationTimeout)
                                            "
                                        >
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="
                                                    py-0
                                                    my-1
                                                    order-12 order-md-1
                                                "
                                                id="step4-first-col"
                                            >
                                                <v-btn
                                                    class="
                                                        mt-2
                                                        mb-8
                                                        mt-md-2
                                                        mb-md-5
                                                        prompt-title-page
                                                    "
                                                    block
                                                    height="40"
                                                    rounded
                                                    color="#FF544A"
                                                    style="font-size: 18px"
                                                    dark
                                                    @click="onDecline()"
                                                    v-if="
                                                        student_status ===
                                                        'PENDING_CONFIRMATION'
                                                    "
                                                    >{{
                                                        $t(
                                                            "message.formSummit.waiver"
                                                        )
                                                    }}</v-btn
                                                >
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="
                                                    d-flex
                                                    py-0
                                                    my-1
                                                    order-md-12
                                                "
                                                id="step4-second-col"
                                            >
                                                <v-btn
                                                    class="
                                                        mt-5
                                                        mb-0
                                                        mt-md-2
                                                        mb-md-5
                                                        prompt-title-page
                                                    "
                                                    block
                                                    height="40"
                                                    rounded
                                                    color="#FF9800"
                                                    style="font-size: 18px"
                                                    dark
                                                    @click="onAccept()"
                                                    v-if="
                                                        student_status ===
                                                        'PENDING_CONFIRMATION'
                                                    "
                                                    >{{
                                                        $t(
                                                            "message.formSummit.confirm"
                                                        )
                                                    }}
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col
                                                cols="8"
                                                sm="12"
                                                md="12"
                                                class="pt-6"
                                            >
                                                <div
                                                    class="pa-0 mt-0 step4__text__size18"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step3.content.question"
                                                        )
                                                    }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="5"
                    id="step-sidebar"
                    class="ma-0 px-0"
                >
                    <v-card id="step-sidebar-card">
                        <v-card-text>
                            <v-row>
                                <v-col cols="10" class="d-flex align-center pb-0 pt-1">
                                    <div class="pa-0 prompt-title">
                                        {{
                                            $t(
                                                "message.formSummit.applicationForm"
                                            )
                                        }}
                                    </div>
                                </v-col>
                                <v-col cols="2" class="pb-1 pt-1">
                                    <v-btn icon @click="closeBar" class="d-flex align-center"
                                        ><v-icon id="dropbar-icon"
                                            >mdi-menu-down</v-icon
                                        ></v-btn
                                    >
                                </v-col>
                            </v-row>
                            <template v-if="this.closeActive">
                                <v-row>
                                    <v-col class="py-0 mt-c-n1">
                                        <div class="pa-0 prompt-caption">
                                            {{ $t("message.formSummit.school") }}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="py-0 pt-1">
                                        <div
                                            class="pa-0 mt-0 step4__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.exam_location
                                            }}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="py-c-14">
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="7"
                                        sm="6"
                                        md="6"
                                        class="pt-0 pb-c-14"
                                        ><div class="pa-0 prompt-title">
                                            {{
                                                $t("message.formSummit.status")
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="5"
                                        sm="6"
                                        md="6"
                                        class="pt-0 pb-c-14"
                                        ><div
                                            class="pa-0 prompt-title d-flex justify-center"
                                        >
                                            <div
                                                v-if="
                                                    student_status ===
                                                    'PENDING_CONFIRMATION'
                                                "
                                            >
                                                <v-chip
                                                    class="ma-0"
                                                    color="#EBEBEC"
                                                >
                                                    <v-icon color="#00C487" left
                                                        >mdi-checkbox-marked-circle
                                                    </v-icon>
                                                    <div
                                                        class="prompt-chip pt-1"
                                                    >
                                                        {{$t("message.formSummit.qualified")}}
                                                    </div>
                                                </v-chip>
                                            </div>
                                            <div
                                                v-if="
                                                    student_status ===
                                                    'NOT_QUALIFY'
                                                "
                                                class="pt-0"
                                                style="padding-top: 10px"
                                            >
                                                <v-chip
                                                    class="ma-0"
                                                    color="#EBEBEC"
                                                >
                                                    <v-icon color="#FF544A" left
                                                        >mdi-close-circle
                                                    </v-icon>
                                                    <div
                                                        class="prompt-chip pt-1"
                                                    >
                                                        {{$t("message.formSummit.noQualified")}}
                                                    </div>
                                                </v-chip>
                                            </div>
                                            <div
                                                v-if="
                                                    student_status ===
                                                    'REJECTION'
                                                "
                                            >
                                                <v-chip
                                                    class="ma-0"
                                                    color="#EBEBEC"
                                                >
                                                    <v-icon color="#FF544A" left
                                                        >mdi-close-circle</v-icon
                                                    >
                                                    <div
                                                        class="prompt-chip pt-1"
                                                    >
                                                        {{$t("message.formSummit.waiver")}}
                                                    </div>
                                                </v-chip>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="py-0 my-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{
                                                $t(
                                                    "message.formSummit.deadlineFirstRound"
                                                )
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div
                                            v-if="confirmationTimeout"
                                            class="pa-0 mt-0 pt-1 step4__text__size18__error"
                                        >
                                            {{ announcementExamResultDate }} -
                                            23:59
                                            {{ $t("message.formSummit.time") }}
                                        </div>
                                        <div
                                            v-else
                                            class="pa-0 mt-0 pt-1 step4__text__size18"
                                        >
                                            {{ announcementExamResultDate }} -
                                            23:59
                                            {{ $t("message.formSummit.time") }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="py-0 my-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{
                                                $t(
                                                    "message.formSummit.deadlineReserveRound"
                                                )
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div
                                            v-if="reservedConfirmationTimeout"
                                            class="pa-0 mt-0 pt-1 step4__text__size18__error"
                                        >
                                            {{
                                                reservedAnnouncementExamResultDate
                                            }}
                                            -
                                            23:59
                                            {{ $t("message.formSummit.time") }}
                                        </div>
                                        <div
                                            v-else
                                            class="pa-0 mt-0 pt-1 step4__text__size18"
                                        >
                                            {{
                                                reservedAnnouncementExamResultDate
                                            }}
                                            -
                                            23:59
                                            {{ $t("message.formSummit.time") }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="py-0 my-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{
                                                $t(
                                                    "message.formSummit.initiationDay"
                                                )
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div
                                            v-if="enrollmentDateTimeout"
                                            class="pt-0 mt-0 pt-1 step4__text__size18__error"
                                        >
                                            {{ enrollmentDate }}
                                        </div>
                                        <div
                                            v-else
                                            class="pt-0 mt-0 pt-1 step4__text__size18"
                                        >
                                            {{ enrollmentDate }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="my-0 py-c-14"
                                    >
                                        <div class="pa-0 sarabun-14">
                                            <label>*</label>
                                            {{
                                                $t(
                                                    "message.formSummit.content1"
                                                )
                                            }}
                                        </div>
                                        <div class="pa-0 sarabun-14">
                                            <label>*</label>
                                            {{
                                                $t(
                                                    "message.formSummit.content2"
                                                )
                                            }}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pr-0 pt-c-14 d-flex align-center"
                                        ><div
                                            class="pa-0 mt-0 mx-auto step4__text__size14"
                                        >
                                            Customer Service LINE
                                        </div></v-col
                                    >
                                    <v-col class="pt-c-14"
                                        ><v-img
                                            :src="
                                                require('../../src/assets/lineBtn.svg')
                                            "
                                            contain
                                            height="36"
                                    /></v-col>
                                </v-row>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="5" class="ma-0 px-0">
                    <div style="height: 480px" id="height-overflow"></div>
                </v-col>
            </v-row>
            <v-dialog v-model="dialog" persistent max-width="450">
                <v-card style="border-radius: 8px">
                    <v-card-text>
                        <v-row class="my-0">
                            <v-col
                                cols="12"
                                md="12"
                                class="d-flex justify-end pb-0"
                            >
                                <v-btn icon dark @click="dialog = false" right>
                                    <v-icon color="#37323c">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="12"
                                class="d-flex justify-center pt-0"
                            >
                                <div v-if="accept === true">
                                    <v-img
                                        :src="
                                            require('@/assets/orange_error.svg')
                                        "
                                        contain
                                        height="36"
                                    />
                                </div>
                                <div v-else>
                                    <v-img
                                        :src="require('@/assets/red_error.svg')"
                                        contain
                                        height="66"
                                    />
                                </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="12"
                                class="my-1 d-flex justify-center"
                            >
                                <div v-if="accept === true">
                                    <div class="prompt-title-500">
                                        {{ $t("message.step4.dialog.topic") }}
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="prompt-title-500">
                                        {{ $t("message.step4.status.waiverTheRights") }}
                                    </div>
                                </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="12"
                                class="my-0 pt-0 d-flex justify-center"
                            >
                                <div
                                    class="
                                        form-label-400
                                        text-center
                                        px-md-0 px-10
                                    "
                                    id="step4-para"
                                >
                                    <div>
                                        {{
                                            $t("message.step4.dialog.content1")
                                        }}
                                    </div>
                                    <div>
                                        {{
                                            $t("message.step4.dialog.content2")
                                        }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mx-2 d-flex">
                            <v-col
                                cols="12"
                                md="6"
                                class="
                                    mb-0
                                    pt-0
                                    mb-md-1
                                    pt-md-4
                                    pb-md-4
                                    order-12 order-md-1
                                "
                            >
                                <v-btn
                                    class="prompt-title-page"
                                    color="#FF9800"
                                    height="40"
                                    block
                                    rounded
                                    dark
                                    @click="dialog = false"
                                    outlined
                                    style="
                                        box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                        font-size: 18px;
                                    "
                                    >{{
                                        $t("message.step4.dialog.cancel")
                                    }}</v-btn
                                >
                            </v-col>

                            <v-col
                                cols="12"
                                md="6"
                                class="
                                    mb-0
                                    pt-0
                                    mb-md-1
                                    pt-md-4
                                    pb-md-4
                                    order-1 order-md-12
                                "
                            >
                                <v-btn
                                    v-if="accept"
                                    class="prompt-title-page"
                                    color="#FF9800"
                                    block
                                    rounded
                                    dark
                                    @click="clickConfirmation"
                                    style="
                                        box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                        font-size: 18px;
                                    "
                                    >{{
                                        $t("message.step4.dialog.next")
                                    }}</v-btn
                                >
                                <v-btn
                                    v-else
                                    class="prompt-title-page"
                                    color="#FF9800"
                                    block
                                    rounded
                                    dark
                                    @click="clickRejection"
                                    style="
                                        box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                        font-size: 18px;
                                    "
                                    >{{
                                        $t("message.formSummit.confirm")
                                    }}</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </v-main>
</template>

<script>
import StepperBar from "./StepperBar";
import LottieAnimation from "lottie-web-vue";
import * as services from "@/services";
import { formatDateTime, formatDateTimeLocale } from "@/utils/date";
import { RegistrationStatusEnum } from "@/constants";
import dayjs from "dayjs";
import i18n from '@/i18n';

export default {
    name: "StepFour",
    data: () => ({
        type: "disclaim",
        dialog: false,
        accept: false,
        closeActive: true,
        student: {},
        id: null,
    }),
    props: {
        registrationFormDetail: Object,
        student_id: Number,
        student_status: String,
        result_type: String,
    },
    computed: {
        locale(){
            return i18n.locale
        },
        announcementExamResultDate() {
            let newDate = Date.parse(
                this.registrationFormDetail
                    ?.announcement_exam_result_deadline_date
            );
            if (newDate) return formatDateTime(newDate);
            else return "";
        },
        reservedAnnouncementExamResultDate() {
            let newDate = Date.parse(
                this.registrationFormDetail
                    ?.reserved_announcement_exam_result_deadline_date
            );
            if (newDate) return formatDateTime(newDate);
            else return "";
        },
        confirmationTimeout() {
            let deadlineConfirmationDate = new Date(
                this.registrationFormDetail
                    ?.announcement_exam_result_deadline_date
            )
            deadlineConfirmationDate.setDate(deadlineConfirmationDate.getDate() + 1)
            deadlineConfirmationDate = deadlineConfirmationDate.setHours(0)
            if (
                dayjs(new Date()).isSameOrBefore(
                    dayjs(deadlineConfirmationDate)
                )
            ) {
                return false;
            }
            return true;
        },
        reservedConfirmationTimeout() {
            let deadlineConfirmationDate = new Date(
                this.registrationFormDetail
                    ?.reserved_announcement_exam_result_deadline_date
            )
            deadlineConfirmationDate.setDate(deadlineConfirmationDate.getDate() + 1)
            deadlineConfirmationDate = deadlineConfirmationDate.setHours(0)
            if (
                dayjs(new Date()).isSameOrBefore(
                    dayjs(deadlineConfirmationDate)
                )
            ) {
                return false;
            }
            return true;
        },
        enrollmentDateTimeout() {
            let deadlineConfirmationDate = new Date(
                this.registrationFormDetail?.enrollment_date
            )
            deadlineConfirmationDate.setDate(deadlineConfirmationDate.getDate() + 1)
            deadlineConfirmationDate = deadlineConfirmationDate.setHours(0)
            if (
                dayjs(new Date()).isSameOrBefore(
                    dayjs(deadlineConfirmationDate)
                )
            ) {
                return false;
            }
            return true;
        },
        enrollmentDate() {
            let newDate = Date.parse(
                this.registrationFormDetail?.enrollment_date
            );
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        resultType() {
            if (this.result_type == "PASS") return i18n.t("message.step4.status.firstRound");
            else if (this.result_type == "RESERVED") return i18n.t("message.step4.status.reserveRound");
            else return "";
        },
        StepperType() {
            if (
                this.registrationFormDetail != null &&
                !(
                    this.registrationFormDetail?.fee == 0 ||
                    this.registrationFormDetail?.fee == null
                )
            )
                return true;
            else return false;
        },
        studentFullName(){
            return `${this.student?.student_detail?.prefix_id?.[`text_${this.locale}`]} ${this.student?.student_detail?.[`name_${this.locale}`]} ${this.student?.student_detail?.[`surname_${this.locale}`]}`
        }
    },
    methods: {
        onAccept() {
            this.dialog = true;
            this.accept = true;
        },
        onDecline() {
            this.dialog = true;
            this.accept = false;
        },
        async clickConfirmation() {
            try {
                this.$emit("loadingUpdate", 1);
                await services.updateStudentRegistrationStatus({
                    token: localStorage.getItem("token"),
                    registration_status:
                        RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION,
                });
                location.reload();
            } finally {
                this.$emit("loadingUpdate", -1);
            }
            this.dialog = false;
        },
        async clickRejection() {
            try {
                this.$emit("loadingUpdate", 1);
                await services.updateStudentRegistrationStatus({
                    token: localStorage.getItem("token"),
                    registration_status: RegistrationStatusEnum.REJECTION,
                });
                location.reload();
            } finally {
                this.$emit("loadingUpdate", -1);
            }
            this.dialog = false;
        },
        closeBar() {
            if (this.closeActive) {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(180deg)";
                document.getElementById("height-overflow").style.height =
                    "180px";
            } else {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(0deg)";
                document.getElementById("height-overflow").style.height =
                    "480px";
            }
            this.closeActive = !this.closeActive;
        },
        async fetchInitStudentQuery() {
            try {
                this.$emit("loadingUpdate", 1);
                const body = {
                    token: localStorage.getItem("token"),
                    query: {
                        selects: {
                            id: true,
                            student_detail: {
                                prefix_id: {
                                    text_th: true,
                                    text_en: true,
                                },
                                name_th: true,
                                surname_th: true,
                                name_en: true,
                                surname_en: true,
                            },
                            register_plan: true,
                        },
                        relations: {
                            student_detail: {
                                prefix_id: true,
                            },
                            register_plan: {
                                program: true,
                                student_year: true,
                            },
                        },
                    },
                };
                const {
                    data: { data },
                } = await services.getStudentWithQuery(body);
                this.student = data.student;
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
    },
    components: { StepperBar, LottieAnimation },
    created() {
        this.fetchInitStudentQuery();
    },
};
</script>

<style lang="scss">
.anim_right {
    width: 220px;
    position: absolute;
    top: -10rem;
    right: -1rem;
    transform: scaleX(-1);
}
.anim_left {
    width: 220px;
    position: absolute;
    top: -10rem;
    left: -1rem;
}
.pb-c-14{
    padding-bottom: 14px;
}
.pt-c-14{
    padding-top: 14px;
}
.pb-c-17{
    padding-bottom: 17px;
}
.py-c-14{
    padding-top: 14px;
    padding-bottom: 14px;
}
.mt-c-n1{
    margin-top: -2px;
}
.step4__text__size18{
    color: #37323c;
    font-family: 'Sarabun';
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

.step4__text__size18__error{
    color: #ff544a;
    font-family: 'Sarabun';
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.step4__text__size14{
    color: #37323c;
    font-family: 'Sarabun';
    font-size: 14px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
</style>